import React, { useState } from "react";
import { MenuItem } from "@mui/material";

import { getTranslateByKey } from "@/main/services/utils";
import WrapperModalRequoteParts from "@/main/components/shared/boxCart/components/modalRequoteParts/modalRequoteParts";
import { RefreshQuoteByGetItemsType } from "../../boxCart/components/types";
import { CartState } from "@/main/store/cart";
import { useThreeDotsQuoteContext } from "../contex";

interface IThreeDotsQuoteRequotePartsProps {
	showButtonRemoveBulkPart: boolean;
	numbersParts: number;
	guidQuote: string;
	dataCart: CartState;
	showPartTypeControl: boolean;
	setIsQuoteBlocked: React.Dispatch<React.SetStateAction<boolean>>;
	loadInfoOrder: (guidQuote: string) => void;
	loadCart: (guidQuote: string) => void;
	refreshQuoteByGetItems: RefreshQuoteByGetItemsType;
}
function ThreeDotsQuoteRequoteParts({
	showButtonRemoveBulkPart,
	numbersParts,
	guidQuote,
	dataCart,
	showPartTypeControl,
	loadCart,
	setIsQuoteBlocked,
	loadInfoOrder,
	refreshQuoteByGetItems,
}: IThreeDotsQuoteRequotePartsProps) {
	const { closeThreeDotsQuote } = useThreeDotsQuoteContext();
	const [isOpenModalRequote, setIsOpenModalRequote] = useState<boolean>(false);

	function handleClickRequoteParts() {
		setIsOpenModalRequote(true);
		closeThreeDotsQuote();
	}

	if (!showButtonRemoveBulkPart) return null;
	return (
		<>
			<MenuItem id={`id-option-button-requoteParts`} onClick={handleClickRequoteParts}>
				{getTranslateByKey("information.requoteParts")}
			</MenuItem>

			<WrapperModalRequoteParts
				dataCart={dataCart}
				setIsQuoteBlocked={setIsQuoteBlocked}
				loadInfoOrder={loadInfoOrder}
				refreshQuoteByGetItems={refreshQuoteByGetItems}
				loadCart={loadCart}
				isOpenModal={isOpenModalRequote}
				guidQuote={String(guidQuote)}
				numbersParts={numbersParts}
				setIsOpenModal={setIsOpenModalRequote}
				closeModal={() => setIsOpenModalRequote(false)}
				showPartTypeControl={showPartTypeControl}
			/>
		</>
	);
}

export { ThreeDotsQuoteRequoteParts };
